<template>
  <div class="card">
    <div class="card-body">
      <BRow class="mb-3">
        <BCol cols="12">
          <InfoForAudio />
        </BCol>
      </BRow>
      <BRow>
        <BCol md="3">
          <ChapterList
              :chapters="chapters"
              @selectedChapter="setCurrentChapterData" />
        </BCol>
        <BCol md="9">
          <AddChaptersForm
              v-if="currentChapter.id"
              :currentChapterData="getCurrentChapterData"
              @selectedChapter="setCurrentChapterData"
          />
        </BCol>
      </BRow>
    </div>
  </div>
</template>

<script>
import InfoForAudio from "../AudioBookEditor/info-audio/InfoForAudio";
import AddChaptersForm from "./AddChaptersForm";
import ChapterList from "./ChapterList";
import * as chapterActions from '../../../store/modules/Chapter/types/actions';
import * as chapterGetters from '../../../store/modules/Chapter/types/getters';
import { mapActions, mapGetters } from 'vuex';

export default {
  name: "AudioIndexComponent",
  components: {
    InfoForAudio,
    AddChaptersForm,
    ChapterList
  },
  data() {
    return {
      currentChapterData: {
        id: '',
        name: '',
        fullName: '',
        artist: '',
        text: '',
        link: '',
      },
    }
  },
  computed: {
    ...mapGetters('Chapter', {
      chapters: chapterGetters.GET_CHAPTERS,
      currentChapter: chapterGetters.GET_CHAPTER
    }),
    getCurrentChapterData() {
      return this.currentChapterData;
    },
    getText() {
      return _.reduce(this.currentChapter.sentences, function(text, sentence) {
        return text + `<p>${sentence.sentence}</p>`;
      }, '');
    }
  },
  methods: {
    ...mapActions('Chapter', {
      getChapterById: chapterActions.GET_CHAPTER,
      getChapters: chapterActions.GET_CHAPTERS,
    }),
    toGetSortedChapters() {
      return _.sortBy(_.values(this.chapters), 'index');
    },
    async audioBookInitialize() {
      try{
        await this.getChapters(this.$route.params.id);
        let firstItem = _.sortBy(_.values(this.chapters), 'index')[0]['id'];
        await this.getChapterById(firstItem);
        await this.setCurrentChapterData()
      } catch (err) {
        console.log(err);
      }
    },
    setCurrentChapterData() {
      this.currentChapterData = {
        id: this.currentChapter.id,
        name: this.currentChapter.name,
        fullName: this.currentChapter.fullName,
        artist: this.currentChapter.artist,
        text: this.getText,
        link: this.currentChapter.link
      }
    }
  },
  async mounted() {
    await this.audioBookInitialize();
  }

}
</script>